import React, { useRef } from 'react'

const DELAY = 0;

const DashboardStateContext = React.createContext();
const DashboardDispatchContext = React.createContext();

function reducer(state, action) {
  return { 
    ...state, 
    ...action, 
    ...(action.buckets !== undefined ? { buckets: [...structuredClone(action.buckets)] } : {}), 
  };
}

function useDashboardState() {
  const context = React.useContext(DashboardStateContext);
  if(!context) throw new Error('useDashboardState must be used in DashboardProvider');
  return context;
}

function useDashboardDispatch() {
  const context = React.useContext(DashboardDispatchContext);
  if(!context) throw new Error('useDashboardDispatch must be used in DashboardProvider');
  return context;
}

function DashboardProvider({ children }) {
  const bucketsRef = useRef(null);
  const [state, dispatch] = React.useReducer(reducer, { 
    buckets: [],
    pageReset: useRef(null),
    scrollSnap: true,
    withTrashedBuckets: false,
  });

  return (
    <DashboardStateContext.Provider value={{ ...state, bucketsRef }}>
      <DashboardDispatchContext.Provider value={dispatch}>
        {children}
      </DashboardDispatchContext.Provider>
    </DashboardStateContext.Provider>
  )
}

function stateUpdateDashboard(dispatch, data) {
  dispatch({...data});
  console.log({...data});

  return new Promise(resolve => {
    setTimeout(() => resolve(true), DELAY);
  });
}

export { 
  DashboardProvider,
  stateUpdateDashboard,
  useDashboardDispatch,
  useDashboardState,
};